<app-main-layout>
  <app-events-page></app-events-page>
</app-main-layout>
